import ArrowUpIcon from "@src/app/assets/icons/cheveron-up.svg?react";
import cx from "classnames";
import type { ReactElement } from "react";
import { useEffect, useState } from "react";

function goTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

export default function ScrollToTop(): ReactElement {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });
  }, []);

  return (
    <button
      id="scroll-to-top"
      className={cx(
        "bg-opacity-60 fixed right-[30px] bottom-[30px] z-99 cursor-pointer rounded-full bg-gray-900 p-1.5 text-white",
        {
          "animate-fade-in-up opacity-1": isVisible,
          "animate-fade-out-up opacity-0": !isVisible,
        },
      )}
      onClick={goTop}
      data-testid="scroll-to-top"
      aria-label="Return to Top"
      tabIndex={0}
    >
      <ArrowUpIcon fill="white" width={20} height={20} />
    </button>
  );
}
